import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=90a451be"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"
import style0 from "./MyMessage.vue?vue&type=style&index=0&id=90a451be&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports